import { getDomain } from '@/utils/getDomain';
import { logger } from '@/utils/logger';

type UrlProp = string | URL | false | null | undefined;

export const getUrl = (url?: UrlProp, base?: UrlProp): URL | null => {
  try {
    const domain = base || getDomain();
    // @ts-expect-error
    return new URL(url, domain);
  } catch (error) {
    logger.error(`Invalid URL`, { url, base });
    return null;
  }
};

export const isValidUrl = (string: string): boolean => {
  if (!string || typeof string !== 'string') {
    return false;
  }

  const urlRegex =
    /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
  return urlRegex.test(string);
};
